import { HttpClient } from "@angular/common/http";
import { Component, Inject, Input } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { switchMap } from "rxjs/operators";
import { Blogpost } from "../../models/blogpost";

@Component({
  selector: "app-blogpost",
  templateUrl: "./blogpost.component.html",
})
export class BlogpostComponent {
  post: Blogpost;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    @Inject("BASE_URL") private baseUrl: string
  ) {}

  ngOnInit() {
    this.route.paramMap
      .pipe(
        switchMap((params: ParamMap) =>
          this.http.get<Blogpost>(
            this.baseUrl + "api/blogpost/" + params.get("id")
          )
        )
      )
      .subscribe(
        (result) => {
          this.post = result;
        },
        (error) => console.error(error)
      );
  }
}
